import { Link } from "react-router-dom";
import { LOGO_URL } from "@/data/site";

const LOGO_WHITE_URL = "/logo-footer.png";

export default function Logo({ className = "h-12", white = false, to = "/" }) {
  const img = (
    <img
      src={white ? LOGO_WHITE_URL : LOGO_URL}
      alt="Equinoxe Studio"
      className={`${className} w-auto object-contain`}
      data-testid="site-logo"
    />
  );
  if (to === null) return img;
  return (
    <Link to={to} aria-label="Equinoxe Studio — accueil" data-testid="logo-link">
      {img}
    </Link>
  );
}
